import { render, staticRenderFns } from "./AppProductSearchBarPc.vue?vue&type=template&id=4901c874&scoped=true"
import script from "./AppProductSearchBarPc.vue?vue&type=script&lang=js"
export * from "./AppProductSearchBarPc.vue?vue&type=script&lang=js"
import style0 from "./AppProductSearchBarPc.vue?vue&type=style&index=0&id=4901c874&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4901c874",
  null
  
)

export default component.exports